import { fg } from '@atlaskit/platform-feature-flags/fg';
import type { HubAppProps } from '@atlassian/company-hub-common/types';

import type { navLinksQuery } from './__generated__/navLinksQuery.graphql';
import { isHideNavMenusEnabled } from './hidden-nav-menus';

type NavigationBarQueryContext = {
	cloudId: string;
	featureFlags: HubAppProps['featureFlags'];
	helpCenterAri: string;
	hubEditMode: HubAppProps['env']['hubEditMode'];
};

/**
 * Restricts the list to portals the seeker can actually reach, matching the
 * legacy help center home page. AGG exposes no per-portal access field, so this
 * can only be applied as a query argument, never as a client-side filter.
 */
export const getPortalsFilter = (): { typeFilter: ['VISIBLE'] } | null =>
	fg('hubs_nav_visible_portals_filter') ? { typeFilter: ['VISIBLE' as const] } : null;

/**
 * Keeps route preloading aligned with the lazy query used by desktop navigation.
 * Relay can reuse the preloaded response only when all query variables match.
 */
export const getNavigationBarQueryVariables = ({
	cloudId,
	featureFlags,
	helpCenterAri,
	hubEditMode,
}: NavigationBarQueryContext): navLinksQuery['variables'] => {
	const isDraftModeEnabled =
		fg('help_hubs_draft_mode') && featureFlags?.help_hubs_draft_mode === true;
	const isConfigurableSiteTreeEnabled =
		fg('help_hubs_configurable_site_tree') &&
		featureFlags?.help_hubs_configurable_site_tree === true;

	return {
		cloudId,
		hubAri: helpCenterAri,
		isDraft: Boolean(hubEditMode) && isDraftModeEnabled,
		isConfigurableSiteTreeEnabled,
		isHideNavMenusEnabled: isHideNavMenusEnabled(),
		isTopicsEnabled: fg('hubs_premium_upsell'),
		portalsFilter: getPortalsFilter(),
	};
};
